import { createSlice } from "@reduxjs/toolkit";
import {
  getPromoCodes,
  getPromoCodeOptions,
  getPromoCode,
  postPromoCode,
  deletePromoCode,
  patchPromoCode,
} from "./promoCodesAction";

const initialState = {
  loading: false,
  error: null,
  success: false,
  codes: {},
  options: [],
  promoCode: null,
};

const promoCodesSlice = createSlice({
  name: "promoCodes",
  initialState,
  reducers: {
    resetPromoCodesError: (state, action) => {
      if (action?.payload) {
        delete state.error[action?.payload];
        if (Object.keys(state.error)?.length === 0) {
          state.error = null;
        }
      } else {
        state.error = null;
      }
      state.loading = false;
      state.success = false;
    },
    resetPromoCodes: (state) => {
      state.codes = {};
    },
    resetPromoCode: (state, action) => {
      state.promoCode = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPromoCodes.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPromoCodes.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.codes = payload;
      })
      .addCase(getPromoCodes.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      // Only the fulfilled case: this list feeds filter dropdowns, so it must
      // not drive the shared `loading` / `error` used by the promo code pages.
      .addCase(getPromoCodeOptions.fulfilled, (state, { payload }) => {
        state.options = payload?.results || [];
      })
      .addCase(getPromoCode.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPromoCode.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.promoCode = payload;
      })
      .addCase(getPromoCode.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(postPromoCode.pending, (state) => {
        state.loading = true;
      })
      .addCase(postPromoCode.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.codes = {
          meta: state?.items?.meta,
          results: [payload, ...(state?.codes?.results || [])],
        };
        state.success = true;
      })
      .addCase(postPromoCode.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(patchPromoCode.pending, (state) => {
        state.loading = true;
      })
      .addCase(patchPromoCode.fulfilled, (state, { payload }) => {
        const { id } = payload;
        const updatedPromoCodes = state.codes?.results?.map((el) => {
          if (el?.id === id) {
            return payload;
          } else {
            return el;
          }
        });
        const newObj = {
          meta: state.codes?.meta,
          results: updatedPromoCodes,
        };
        state.codes = newObj;
        state.loading = false;
        state.success = true;
      })
      .addCase(patchPromoCode.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(deletePromoCode.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletePromoCode.fulfilled, (state, { payload }) => {
        const updatedPromoCodes = state.codes?.results?.filter(
          (el) => el?.id !== payload?.id
        );
        const newObj = {
          meta: state.codes?.meta,
          results: updatedPromoCodes,
        };
        state.codes = newObj;
        state.loading = false;
      })
      .addCase(deletePromoCode.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });
  },
});
export const { resetPromoCodesError, resetPromoCode, resetPromoCodes } =
  promoCodesSlice.actions;
export default promoCodesSlice.reducer;
